// extracted by mini-css-extract-plugin
export default {"tooltip":"pW-z","arrow":"qW-z"};